import React, {Component, PropTypes} from 'react'
import './InfoBlockTotalStuff.scss'

class InfoBlockTotalStuff extends Component {
    static propTypes = {
        total: PropTypes.number,
    }

    render() {
        return (
            <div className="InfoBlockTotalStuff">
                Всего грузов: {this.props.total}
            </div>
        )
    }
}

export default InfoBlockTotalStuff



// WEBPACK FOOTER //
// ./client/components/InfoBlockTotalStuff/InfoBlockTotalStuff.js